import React, { FunctionComponent, ReactNode, useRef } from 'react'
import { PaymentScheduleTitle } from '../PaymentScheduleTitle'
import { ModuleContainer } from '../ModuleContainer'
import { PaymentSchedule } from '../PaymentSchedule'
import { Divider, Override, DesignLanguage, useIsDesignLanguage } from '@afterpaytouch/core'
import { useCheckoutState, useIsBillingAgreementApprovalProcess, useSummaryLayout } from '../../state'
import { PaymentMethod } from '../PaymentMethod'
import { PageLayout } from '../../model'
import { PaymentScheduleExperiment } from '../PaymentScheduleExperiment'
import { PaymentDay } from '../PaymentDay'
import { AutopayButton } from '../AutopayToggle/AutopayButton'
import { PreferredCardTopazError } from '../PreferredCardTopazError'

interface PaymentScheduleContainerProps {
  testNameSpace?: string
}

export const PaymentScheduleContainer: FunctionComponent<PaymentScheduleContainerProps> = ({ testNameSpace = '' }) => {
  const paymentScheduleRef = useRef<null | HTMLDivElement>(null)

  const { cashTooltipShown } = useCheckoutState()
  const isBillingAgreementApprovalProcess = useIsBillingAgreementApprovalProcess()
  const isBronteDesignLanguage = useIsDesignLanguage(DesignLanguage.Bronte)

  const { variant: summaryVariant } = useSummaryLayout()

  const renderPaymentScheduleAndPaymentMethod = (): ReactNode => {
    const showPaymentScheduleExperiment = summaryVariant === 'E'

    return showPaymentScheduleExperiment ? (
      <PaymentScheduleExperiment />
    ) : (
      <>
        <PaymentScheduleTitle />
        <ModuleContainer extraBottomMargin={cashTooltipShown} nested={!isBronteDesignLanguage}>
          <PaymentSchedule />
          {isBronteDesignLanguage && <Divider kind='Hairline' />}
          <PaymentDay />
          <AutopayButton />
          <PaymentMethod
            negativeMargins={isBronteDesignLanguage}
            layout={PageLayout.Summary}
            optionRadiusOverride={Override.DisabledTopBorderRadius}
            showErrorMessage={false}
          />
        </ModuleContainer>
      </>
    )
  }

  return (
    <>
      <div ref={paymentScheduleRef} {...(testNameSpace.length > 0 && { 'data-testid': `${testNameSpace}-payment-schedule-container` })}>
        {!isBillingAgreementApprovalProcess ? (
          renderPaymentScheduleAndPaymentMethod()
        ) : (
          <ModuleContainer showBorder={isBronteDesignLanguage} extraBottomMargin={cashTooltipShown}>
            <PaymentMethod layout={PageLayout.Summary} />
          </ModuleContainer>
        )}
      </div>
      <PreferredCardTopazError />
    </>
  )
}
